<template>
    <div>
        <h4>Create with XLS</h4>
        <div>   
            <p>Click on Browse to upload a populated .XLS file</p>
            <!--h3 style="margin-bottom: 2rem;">Bulk device upload using file</h3-->
            <b-form-file accept=".XLS, .xls, .XLSX, .xlsx" no-drop ref="fileInput" v-model="file" :state="Boolean(file)" placeholder="Select .XLS, .xls, .XLSX, .xlsx file..."></b-form-file>
        </div>

        <div v-show="loading_file" style="margin-top: 1rem">
            <i class="fa fa-spinner fa-spin"></i> Loading File
        </div>

        <div v-if="serial_number_list.length > 0" class="form-group  text-left" style="margin-top: 2rem;">
            <label>Serials</label>
            <div style="margin-top: 0.5rem; margin-bottom: 1rem;">
                <b-table id="items-table" outlined bordered
                    :items="serial_number_list"
                    style="width: 50%; text-align: left;">
                </b-table>
            </div>
        </div>
        <b-btn v-show="serial_number_list.length > 0" style="margin-top: 1rem;" class="btn btn-md btn-success" variant="success" :disabled="is_creating" v-on:click="clickedCreate">
            <i v-show="is_creating" class="fa fa-spinner fa-spin"></i> Create
        </b-btn>
    </div>
</template>

<script>

import utils from "../../utils.js"

import DEVICE_API from '../../api/device'
import DEVICE_GROUP_API from '../../api/device_group'

import Papa from "papaparse"

import bTable from 'bootstrap-vue/es/components/table/table'

import XLSX from 'xlsx'

import moment from 'moment'

const SERIAL_NAME_COLUMN = "Serial"

export default {
    data () {
        return {
            file: null,

            disable_all: false,
            selected_product: "IP051",
            selected_device_group: "default",

            loading_file: false,

            is_creating: false,

            serial_number_list: []
        }
    },

	mounted () {
		console.log('XLSUploadComponent mounted')
    },

    components: {
        bTable
    },

    watch: {
        file: function(val, oldVal) {
            console.debug("File Watch: ", val)
             
            if(val === undefined || val == null) {
                this.loading_file = false
            }    
            else {
                this.serial_number_list = []
                this.loading_file = true    
                console.log("user presssed Cancel for file!") 
                
                // check if user selected a valid file type     
                if(val != null) { 
                    let fileExtention = val.name.split('.').pop().toUpperCase()

                    if( fileExtention !== 'XLS' && fileExtention !== 'XLSX' ) {
                        utils.makeToast(this.$bvToast, "Error", "danger", "Please select a valid val type.")
                        this.loading_file = false
                        this.file = null
                        return
                    }
                }

                if (val) {
                    const reference = this

                    this.showSimilarEntries = false
                    this.showInvalidHeaders = false
                    this.showInvaliFile = false

                    this.serialNumberWarningDuplicateEntries = ""

                    var rABS = true
                    var reader = new FileReader()

                    reader.onload = function(response) {
                        var data = response.target.result
                        if(!rABS) {
                            data = new Uint8Array(data)
                        }
                        var workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'})
                        console.log(workbook);

                        const sheetName = workbook.SheetNames[0];
                        const sheetArrayJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
                        console.log(sheetArrayJson);

                        // delay execution so we can see the spinner    
                        setTimeout(reference.parseData, 1000, sheetArrayJson)
                    };

                    if(rABS) {
                        reader.readAsBinaryString(val)
                    } else {
                        reader.readAsArrayBuffer(val)
                    }
                }
            }
        },
    },

    methods: {
        parseFile: function() {
            console.log("parseFile")

            Papa.parse(this.file, {
                step: function(results) {
                    console.log("Row:", results.data)
                }
            });
        },

        parseData(data) {
            console.log("parseData done!", data);

            var error_serials = null

            var should_show_too_many_lines = false

            if (data) {
                if (data.length > 200) {
                    should_show_too_many_lines = true;
                } else {
                    const reference = this

                    data.forEach(function(item) {
                        const serial_number = item[SERIAL_NAME_COLUMN]

                        if (!reference.serial_number_list.includes(serial_number)) {
                            const serialNumberFormatted = serial_number.trim()

                            if (utils.validateSerialNumber(serialNumberFormatted)) {
                                const new_item = {
                                    'Serial' : serial_number
                                }
                                reference.serial_number_list.push(new_item)
                            } else {
                                if (error_serials == null) {
                                    error_serials = serial_number
                                } else {
                                    error_serials += ", " + serial_number
                                }
                            }
                        }
                    }); 
                    
                    if (error_serials != null) {
                        utils.makeToast(this.$bvToast, "Warning", "warning", "The following serial number(s) are wrong: " + error_serials + ". Serial numbers need to be 17 digits long");
                    }
                }
            }

            if (this.serial_number_list.length == 0 && error_serials == null) {
                utils.makeToast(this.$bvToast, "Warning", "warning", 'There is no valid data in the Spreadsheet')
            } else if (should_show_too_many_lines) {
                utils.makeToast(this.$bvToast, "Warning", "warning", 'XLS file upload is limited to 200 entries!')
            }

            this.loading_file = false
            this.file = null
        },

        clickedCreate: function() {
            this.disable_all = true
            this.is_creating = true

            this.createGroup()
        },

        createGroup: function() {
            const device_group_name = "GROUP-BULK-" + this.selected_product + "-" + moment().format('MMMM Do YYYY, hh:mm:ss')

            console.log("device_group_name: " + device_group_name)
            // GROUP-BULK-IP051-Thu Aug 22 2019 17:03:07 GMT+0100 (British Summer Time)

            const postParamsAddNewGroup = {
                product_name: this.selected_product,
                device_group_name: device_group_name,
                branch: "undefined",
                sw_version: "undefined",
                variant: "undefined",
                signing_version: "undefined"
            }

            const reference = this

            DEVICE_GROUP_API.addGroup(
              postParamsAddNewGroup,
              () => {
                console.debug("Added Group");

                reference.createDevices(device_group_name)
              },
              e => {
                    console.debug(e)

                    reference.disable_all = false
                    reference.is_creating = false

                    utils.makeToast(reference.$bvToast, "Error", "danger", 'There was a problem creating one of more device')
              }
            );
        },

        createDevices: function(group_name) {
            var list_serials = []
            
            for (const serialObj of this.serial_number_list) {
                list_serials.push(serialObj['Serial'])
            }

            const params = {
                serial_number_list : list_serials,
                product_name: this.selected_product,
                device_group_name: group_name
            }

            const reference = this;

            DEVICE_API.addMultiple(params,
                () => {
                    reference.disable_all = false
                    reference.is_creating = false

                    reference.serial_number_list = []

                    utils.makeToast(reference.$bvToast, "Success", "success", 'Your new devices are ready to use!')
                },
                e => {
                    console.debug(e)

                    reference.disable_all = false
                    reference.is_creating = false

                    utils.makeToast(reference.$bvToast, "Error", "danger", 'There was a problem creating one of more device')
                }
            );
        }
    },
}
</script>

<style lang="stylus" scoped>
.container-color
    display: flex; 
    flex-direction: row; 
    align-items: center; 

</style>